import { useState } from "react";

const useImageManager = (deed, setHasUnsavedImageChanges) => {
  const [newPics, setNewPics] = useState(new Map());
  const [existingPics, setExistingPics] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const fileMap = new Map();

    files.forEach((file) => {
      const url = URL.createObjectURL(file);
      fileMap.set(url, file);
    });

    setNewPics((prev) => new Map([...prev, ...fileMap]));
    setHasUnsavedImageChanges(true);
  };

  const handleDeletePic = (picUrl) => {
    setExistingPics((prev) => prev.filter((pic) => pic !== picUrl));

    setNewPics((prev) => {
      if (!prev.has(picUrl)) return prev;
      const next = new Map(prev);
      next.delete(picUrl);
      URL.revokeObjectURL(picUrl);
      return next;
    });

    setHasUnsavedImageChanges(true);
  };

  // Free any blob URLs we created for new uploads.
  const cleanup = () => {
    for (const url of newPics.keys()) {
      URL.revokeObjectURL(url);
    }
  };

  const reset = () => {
    cleanup();
    setNewPics(new Map());
    setExistingPics(deed?.pics || []);
  };

  return {
    newPics,
    existingPics,
    handleFileChange,
    handleDeletePic,
    cleanup,
    reset,
    setExistingPics,
  };
};

export default useImageManager;
